export interface CartRequest {
  raffleId?: number;
  subscriptionId?: number;
  totalTickets: number;
  totalAmount: number;
  purchaseType: PurchaseType;
}

export interface Cart extends CartRequest {
  id: number;
  status: string;
  raffleTitle?: string;
  raffleImage?: string;
  influencerName?: string;
  subscriptionType?: string;
  isTicketFree: boolean;
}

// import { PurchaseTypeEnum } from './purchaseTypeEnum';

// export interface UserCartRequestViewModel {
//   raffleId: number | null;
//   subscriptionId: number | null;
//   totalTickets: number | null;
//   totalAmount: number | null;
//   purchaseType: PurchaseTypeEnum;
// }

export enum PurchaseType {
  Raffle = 1,
  Subscription = 2,
}

// export interface UserCartResponseViewModel extends UserCartRequestViewModel {
//   id: number;
//   status: string;
//   raffleTitle?: string;
//   raffleImage?: string;
//   influencerName?: string;
//   subscriptionType?: string;
//   isTicketFree: boolean;
// }